import React from 'react';
import { Control, Controller } from 'react-hook-form';
import { Checkbox } from '@mui/material';
import { CustomChangeEvent } from '../../../@types/helper';

interface IControlledLabelledCheckBoxProps{
    name : string;
    label : string;
    control : Control<any, any>;
    defaultValue : boolean;
    className ?: string;
    disabled ?: boolean;
}

/**
 * @requires react-hook-form - this component is only meant to be used with react-hook-form
 */
const ControlledLabelledCheckBox = (props : IControlledLabelledCheckBoxProps) => {
    return (
        <Controller
            name={props.name}
            control={props.control}
            defaultValue={props.defaultValue}
            render={(x) => (
                <div className='fdr aic'>
                    <Checkbox
                        name={x.field.name}
                        onChange={(e : CustomChangeEvent, checked : boolean) : void => {
                            x.field.onChange(e, checked);
                        }}
                        className={props.className}
                        checked={!!x.field.value}
                        disabled={props.disabled}
                    />
                    <span className={props.disabled ? 'cg3' : ''}>{props.label}</span>
                </div>
            )}
        />
    );
};

export default ControlledLabelledCheckBox;